"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.IntermediateNodeSchema = exports.IntermediateNodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../types/tape-builder-base");
const types_1 = require("../../uiNodes/tapes/direct-insert-borrowing-base-report/types");
exports.artifactType = 'directInsertBorrowingBaseReport';
const BaseDbNodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    type: zod_1.z.literal(exports.artifactType),
    externalFilename: zod_1.z.null(),
    loanProductSlug: zod_1.z.null(),
    creditFacilitySlug: zod_1.z.string(),
});
exports.IntermediateNodeConfigSchema = types_1.IntermediateRecordConfigSchema;
exports.IntermediateNodeSchema = BaseDbNodeTypeSchema.extend({
    configuration: types_1.IntermediateRecordConfigSchema,
});
// *** Db Configuration ***
exports.NodeConfigSchema = types_1.IntermediateRecordConfigSchema.extend({
    cashResponseTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Optional slug for cash response tape artifact')
        .optional()
        .nullable(),
});
// *** Db Record ***
exports.NodeTypeSchema = BaseDbNodeTypeSchema.extend({
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map